// extracted by mini-css-extract-plugin
export default {"header":"allCampaigns_header__P5x0k","section":"allCampaigns_section__CPmhb","campaign":"allCampaigns_campaign__lkhmg"};